import cookies from 'js-cookie';
import _toLower from 'lodash/toLower';
import config from '@root/config';

 export const isOptimusMode = () => {
    const optimus = cookies.get(config.OPTIMUS_KEY);
    return _toLower(optimus) === _toLower(config.OPTIMUS_VALUE);
};
